import React from 'react';
import { ChevronDown, ChevronRight, Code } from 'lucide-react';
import { OmdPanelIcon } from '../omdPanelIcons';

export function OmdRawJsonSection({ product }: { product: unknown }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="rounded-lg border border-app-border overflow-hidden mt-4">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-xs font-medium text-app-text-subtle hover:bg-app-hover"
      >
        {open ? <ChevronDown className="w-3.5 h-3.5 shrink-0 text-app-text-subtle" /> : <ChevronRight className="w-3.5 h-3.5 shrink-0 text-app-text-subtle" />}
        <OmdPanelIcon icon={Code} size="sm" />
        Rohdaten (JSON)
      </button>
      {open && (
        <pre className="px-3 pb-3 text-xs leading-relaxed text-app-text-muted overflow-x-auto whitespace-pre-wrap break-words max-h-64">
          {JSON.stringify(product, null, 2)}
        </pre>
      )}
    </div>
  );
}
